import { slices } from "@/constants/sliceNames";
import axios from "axios";

import store from "../store/store";

import { API_ROOT } from "./apiConfig";

const axiosIns = axios.create({
  baseURL: API_ROOT,
});

export const axiosplain = axios.create({
  baseURL: "",
});

axiosIns.interceptors.request.use((config) => {
  config.headers["Authorization"] = `Bearer ${store.getState()[slices.auth].userToken}`;
  // config.headers["Access-Control-Allow-Origin"] = "*";
  // config.headers['Content-Type'] = "text/plain"

  return config;
});

export default axiosIns;
